import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { label: '首页', to: '/', match: (p: string) => p === '/' },
  { label: '电影', to: '/category/movie', match: (p: string) => p.startsWith('/category/movie') },
  { label: '电视剧', to: '/category/tv', match: (p: string) => p.startsWith('/category/tv') },
  { label: '热门', to: '/category/hot', match: (p: string) => p.startsWith('/category/hot') },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?keyword=${encodeURIComponent(value)}` : '/search');
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-background-50/80 backdrop-blur'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-500 text-background-950 flex items-center justify-center">
            <i className="ri-film-line text-xl"></i>
          </span>
          <span className="font-heading font-black text-lg md:text-xl text-foreground-950 whitespace-nowrap">
            亚洲中文字幕在线观看
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV_ITEMS.map((item) => {
            const active = item.match(location.pathname);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  active
                    ? 'text-primary-500'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
          <Link
            to="/about"
            className={`px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
              location.pathname === '/about'
                ? 'text-primary-500'
                : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
            }`}
          >
            关于
          </Link>
        </nav>

        <div className="flex items-center gap-2">
          <form onSubmit={handleSearch} className="hidden md:flex items-center">
            <div className="flex items-center bg-background-100 border border-background-200 rounded-md px-3 h-9 w-56 focus-within:border-primary-400 transition-colors">
              <i className="ri-search-line text-foreground-500 text-sm"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、演员…"
                className="bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-500 px-2 w-full"
              />
            </div>
          </form>
          <Link
            to="/search"
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-xl"></i>
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <div className="px-4 py-3 flex flex-col gap-1">
            <form onSubmit={handleSearch} className="mb-2">
              <div className="flex items-center bg-background-100 border border-background-200 rounded-md px-3 h-10">
                <i className="ri-search-line text-foreground-500 text-sm"></i>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索影片、演员…"
                  className="bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-500 px-2 w-full"
                />
              </div>
            </form>
            {[...NAV_ITEMS, { label: '关于', to: '/about', match: (p: string) => p === '/about' }].map((item) => {
              const active = item.match(location.pathname);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`px-3 py-3 rounded-md text-sm font-medium cursor-pointer ${
                    active ? 'bg-primary-100 text-primary-900' : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </header>
  );
}